import { isBeekeeperAdminAllowed, isBeekeeperIntegrationEnabled } from '@lumapps/beekeeper/ducks/selectors';
import { isBeekeeperFeatureEnabled } from '@lumapps/features';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_FORMS, BEEKEEPER_FORMS_LITE, BEEKEEPER_FORMS_LIBRARY } from '../constants';

export const isBeekeeperFormsEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_FORMS);
export const isBeekeeperFormsLiteEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_FORMS_LITE);
export const isBeekeeperFormsLibraryEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_FORMS_LIBRARY);

export const isFormsEnabled = createSelector(
    isBeekeeperIntegrationEnabled,
    isBeekeeperFormsEnabled,
    isBeekeeperFormsLiteEnabled,
    (isIntegrationEnabled, isFormsFFEnabled, isFormsLiteEnabled) =>
        isIntegrationEnabled && (isFormsFFEnabled || isFormsLiteEnabled),
);
/**
 * Determines if the current user has access to forms feature.
 * Access rules:
 * - Admins: Can access with either forms_management OR forms_lite enabled
 */
export const hasBeekeeperFormsAccess = createSelector(
    isBeekeeperAdminAllowed,
    isBeekeeperFormsEnabled,
    isBeekeeperFormsLiteEnabled,
    (isAdmin, hasFormsManagement, hasFormsLite) => {
        if (isAdmin) {
            // Admins can access with either forms_management OR forms_lite
            return hasFormsManagement || hasFormsLite;
        }

        return false;
    },
);
